
import common from '@/pages/common/store'
const modules = {}
modules.common = common

export default {
  namespaced: true,
  modules: modules
}
